import { SecondaryHeader } from './SecondaryHeader';

export default SecondaryHeader;
